export default __webpack_public_path__ + "static/media/img-hero.2c66d85a.jpg";